<template>
  <el-menu class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
    <router-link to="/sys/index">
      <el-menu-item index="Index">
        <template slot="title">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </template>
      </el-menu-item>
    </router-link>

    <el-submenu :index="menu.name" v-for="menu in menuList">
      <template slot="title">
        <i :class="menu.icon"></i>
        <span>{{ menu.title }}</span>
      </template>

      <router-link :to="item.path" v-for="item in menu.children">
        <el-menu-item :index="item.name">
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </template>
        </el-menu-item>
      </router-link>
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  name: "SideMenu",
  data() {
    return {
      menuList: [
        {
          name: "SysManage",
          title: "系统管理",
          icon: "el-icon-s-operation",
          path: "",
          component: "",
          children: [
            {
              name: "SysUser",
              title: "用户管理",
              icon: "el-icon-s-custom",
              path: "/sys/users",
              children: [],
            },
          ],
        },
        {
          name: "SysApp",
          title: "App管理",
          icon: "el-icon-s-tools",
          path: "",
          children: [
            {
              name: "SysAppInfo",
              title: "apk信息",
              icon: "el-icon-folder",
              path: "/sys/apksinfo",
              children: [],
            },
            {
              name: "SysApkVersionInfo",
              title: "蓝牙版本信息",
              icon: "el-icon-folder",
              path: "/sys/appversioninfo",
              children: [],
            },
            {
              name: "SysApkVersion",
              title: "蓝牙版本上传",
              icon: "el-icon-folder",
              path: "/sys/appversion",
              children: [],
            },
            {
              name: "SysApkWifiVersionInfo",
              title: "wifi版本信息",
              icon: "el-icon-folder",
              path: "/sys/wifiappversioninfo",
              children: [],
            },
            {
              name: "SysWifiApkVersion",
              title: "wifi版本上传",
              icon: "el-icon-folder",
              path: "/sys/wifiappversion",
              children: [],
            },
          ],
        },
        {
          name: "DdImageManage",
          title: "分化图",
          icon: "el-icon-s-tools",
          path: "",
          component: "",
          children: [
            {
              name: "DdImageInfo",
              title: "分化图信息",
              icon: "el-icon-s-goods",
              path: "/sys/ddImageInfo",
              children: [],
            },
            {
              name: "DdImage",
              title: "分化图新增",
              icon: "el-icon-s-goods",
              path: "/sys/ddImage",
              children: [],
            },
          ],
        },
        {
          name: "AdManage",
          title: "广告管理",
          icon: "el-icon-s-goods",
          path: "",
          component: "",
          children: [
            {
              name: "Advertise",
              title: "广告管理",
              icon: "el-icon-s-goods",
              path: "/sys/ad",
              children: [],
            },
          ],
        },
        {
          name: "SysActiveCode",
          title: "激活码管理",
          icon: "el-icon-s-tools",
          path: "",
          children: [
            {
              name: "ActiveCode",
              title: "激活码信息",
              icon: "el-icon-s-order",
              path: "/sys/ActiveCodeInfo",
              children: [],
            },
            {
              name: "Generate",
              title: "生成激活码",
              icon: "el-icon-s-order",
              path: "/sys/Generate",
              children: [],
            },
          ],
        },
        {
          name: "SysOrders",
          title: "订单管理",
          icon: "el-icon-s-tools",
          path: "",
          children: [
            {
              name: "SysOrders",
              title: "订单信息",
              icon: "el-icon-s-order",
              path: "/sys/orders",
              children: [],
            },
          ],
        },
        {
          name: "SysShop",
          title: "商城管理",
          icon: "el-icon-s-tools",
          path: "",
          children: [
            {
              name: "SysShop",
              title: "上传图片",
              icon: "el-icon-s-order",
              path: "/sys/shop",
              children: [],
            },
            {
              name: "SysShopInfo",
              title: "商品信息",
              icon: "el-icon-s-order",
              path: "/sys/shopinfo",
              children: [],
            },
          ],
        },
        {
          name: "SysDownload",
          title: "下载管理",
          icon: "el-icon-s-tools",
          path: "",
          children: [
            {
              name: "SysCount",
              title: "下载列表",
              icon: "el-icon-s-order",
              path: "/sys/download",
              children: [],
            },
          ],
        },
        {
          name: "AppErrlog",
          title: "Wifi日志",
          icon: "el-icon-s-tools",
          path: "",
          component: "",
          children: [
            {
              name: "AppErrlogInfo",
              title: "日志信息",
              icon: "el-icon-s-goods",
              path: "/sys/appErrlog",
              children: [],
            }
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.el-menu-vertical-demo {
  height: 100%;
}
a {
  text-decoration: none;
}
</style>
